module.exports = __webpack_public_path__ + "static/media/red-badge.49ec90c2.svg";